exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-table{font-family:var(--ds-type-system-sans-lining);font-size:var(--ds-type-scale-0);line-height:var(--ds-type-leading-lower);max-width:100%;width:100%}.ds-table td{border-bottom:var(--ds-border-rule)}.ds-table td,.ds-table th{padding:.75rem var(--ds-grid-gap) .75rem 0}.ds-table th{border-bottom:var(--ds-border-rule--emphasised);font-weight:700;text-align:left}.ds-table--scroll{overflow-x:auto;width:100%}", ""]);

// exports
exports.locals = {
	"ds-table": "ds-table",
	"ds-table--scroll": "ds-table--scroll"
};